import { gql } from 'graphql-tag'
import { fragmentBlockCallToAction } from '../../../core/data-layer/blocks/fragments'
import { fragmentGlobalDataCountry, fragmentGlobalDataCurrency } from '../../../core/data-layer/global-data/fragments'
import { fragmentModuleMedia } from '../../../core/data-layer/modules/fragments'
import queryPageFields from '../../../core/data-layer/pages/page/query-page-fields'

export default gql`
    ${fragmentGlobalDataCountry}
    ${fragmentGlobalDataCurrency}
    ${fragmentModuleMedia}
    ${fragmentBlockCallToAction}
    query($slug: String!, $parentSlug: String!, $locale: String!, $preview: Boolean!) {
        page: pagePaymentMethodsGuidesRegionCountryCollection(limit: 1, where: { slug: $slug, parent: { slug: $parentSlug } }, locale: $locale, preview: $preview) {
            items {
                ${queryPageFields}
                parent {
                    sys {
                        id
                    }
                }
                shortDescription
                longDescription {
                    json
                }
                image {
                    ...ModuleMediaFragment
                }
                country {
                    ...on GlobalDataCountry {
                        ...GlobalDataCountryFragment
                    }
                }
                currency {
                    ...on GlobalDataCurrency {
                        ...GlobalDataCurrencyFragment
                    }
                }
                channelOnlineCollection(limit: 25) {
                    items {
                        sys {
                            id
                        }
                        paymentMethod {
                            sys {
                                id
                            }
                        }
                    }
                }
                channelInPersonCollection(limit: 25) {
                    items {
                        sys {
                            id
                        }
                        paymentMethod {
                            sys {
                                id
                            }
                        }
                    }
                }
                cardsPerCapita
                population
                paymentsStatistics {
                    ...on PaymentsPaymentMethodCountryStatistics {
                        onlineBanking
                        localCard
                        globalCard
                        cash
                        buyNowPayLater
                        wallet
                        prepaidCard
                        others
                    }
                }
                desktopStatistics
                mobileStatistics
                callToAction {
                    ...BlockCallToActionFragment
                }
            }
        }
    }
`
